"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const countries_1 = require("../countries");
const address_1 = __importDefault(require("../address"));
const errors_1 = __importStar(require("../errors"));
const joi_1 = __importDefault(require("joi"));
class Contact {
    constructor(id, name, email, address, phone, ein, partnerId, create, roles) {
        var _a;
        this.id = id;
        this.name = name;
        this.address = address;
        this.phone = phone;
        this.ein = ein;
        this.partnerId = partnerId;
        this.create = create;
        this.roles = roles;
        this.email = (_a = email === null || email === void 0 ? void 0 : email.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    }
    static fromObj(data) {
        var _a, _b, _c;
        return new Contact((_a = data === null || data === void 0 ? void 0 : data.id) !== null && _a !== void 0 ? _a : "", (_b = data === null || data === void 0 ? void 0 : data.name) !== null && _b !== void 0 ? _b : "", (_c = data === null || data === void 0 ? void 0 : data.email) !== null && _c !== void 0 ? _c : "", (data === null || data === void 0 ? void 0 : data.address) ? address_1.default.fromObj(data.address) : undefined, data === null || data === void 0 ? void 0 : data.phone, data === null || data === void 0 ? void 0 : data.ein, data === null || data === void 0 ? void 0 : data.partnerId, data === null || data === void 0 ? void 0 : data.create, data === null || data === void 0 ? void 0 : data.roles);
    }
    static empty() {
        return new Contact("", "", "", undefined, "", "", "", undefined, undefined);
    }
    static isEqual(a, b) {
        return (a.id === b.id &&
            a.name === b.name &&
            a.email === b.email &&
            ((!a.address && !b.address) || a.equals(b)) &&
            a.phone === b.phone &&
            a.ein === b.ein &&
            a.partnerId === b.partnerId &&
            a.create === b.create);
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
        this.email = data.email;
        this.phone = data.phone;
        this.ein = data.ein;
        this.address =
            data.address && data.address.country
                ? address_1.default.fromObj(data.address)
                : undefined;
        this.partnerId = data.partnerId;
        this.create = data.create;
    }
    equals(obj) {
        var _a;
        if (obj instanceof Contact) {
            return (this.id === obj.id &&
                this.name === obj.name &&
                this.email === obj.email &&
                this.phone === obj.phone &&
                this.partnerId === obj.partnerId &&
                ((_a = this.address) === null || _a === void 0 ? void 0 : _a.equals(obj.address)) &&
                this.create === obj.create);
        }
        return false;
    }
    isEmpty() {
        var _a;
        return (!this.id &&
            !this.name &&
            !this.email &&
            !this.phone &&
            !this.ein &&
            !this.partnerId &&
            !((_a = this.address) === null || _a === void 0 ? void 0 : _a.isEmpty()));
    }
    validate(path, emailOptional = false, addressRequired = true) {
        const errors = [];
        if (this.email) {
            const validateEmail = joi_1.default.string()
                .email()
                .required()
                .validate(this.email);
            if ("error" in validateEmail) {
                errors.push(new errors_1.default(errors_1.eErrorCode.EMAIL_INVALID, `${path}.email`));
            }
        }
        else if (!emailOptional) {
            errors.push(new errors_1.default(errors_1.eErrorCode.EMAIL_NOT_SET, `${path}.email`));
        }
        errors.push(...this.validateOptional(path, addressRequired));
        return errors;
    }
    validateOptional(path, addressRequired) {
        const errors = [];
        if (addressRequired && this.address && !this.address.isEmpty()) {
            errors.push(...this.address.validate(`${path}.address`, countries_1.postalRequired(this.address.country)));
        }
        return errors;
    }
    static defaultWhitelabelBroker() {
        return new Contact("nathan.trimble@loadsure.net", "Nate Trimble", "nathan.trimble@loadsure.net", undefined, "+14016800194", undefined, "@LOADSURE");
    }
    static defaultUnderwriterContact() {
        return new Contact("taylor.walker@loadsure.net", "Taylor Walker", "taylor.walker@loadsure.net", undefined, "+18608574195", undefined, "@LOADSURE");
    }
}
exports.default = Contact;
//# sourceMappingURL=contact.class.js.map